import axios from 'axios'
import { Urls } from "../../../store/urls";
import { ServiceUrls } from "../../serviceUrls";

export const getCmsPermissionListRepo = (id) => {
  let url = id ? Urls.GET_CMS_PERMISSION_LIST_API + id : Urls.GET_CMS_PERMISSION_LIST_API
  return axios({
    method: 'GET',
    url: url,
  })
}

export const filterCmsPermissionListRepo = (data) => {
  return axios({
    method: 'GET',
    url: Urls.GET_CMS_PERMISSION_LIST_API,
    params: data
  })
}

export const editCmsPermissionRepo = (data, id) => {
  return axios({
    method: 'PUT',
    url: Urls.GET_CMS_PERMISSION_LIST_API + id + '/',
    data: data
  })
}

export const getCmsContentTypeRepo = (data) => {
  return axios({
    method: 'GET',
    url: Urls.GET_CMS_CONTENT_TYPE,
    params: data
  })
}
export const postCmsPermissionRepo = (data) => {
  return axios({
    method: 'POST',
    url: Urls.GET_CMS_PERMISSION_LIST_API,
    data: data
  })
}
// export const deleteCmsPermissionRepo = (data,id) => {
//   return axios({
//       method: 'DELETE',
//       url:Urls.GET_CMS_PERMISSION_LIST_API+id,
//       data:data
//   })
// } 

export const getCmsGroupListRepo = (id, data) => {
  let url = id ? Urls.GET_CMS_GROUPS_LIST + id : Urls.GET_CMS_GROUPS_LIST
  return axios({
    method: 'GET',
    url: url,
    params: data
  })
}

export const addCmsGroupRepo = (data) => {
  return axios({
    method: 'POST',
    url: Urls.GET_CMS_GROUPS_LIST,
    data: data
  })
}

export const updateCmsGroupRepo = (data, id) => {
  return axios({
    method: 'PUT',
    url: Urls.GET_CMS_GROUPS_LIST + id + '/',
    data: data
  })
}

export const getUserListRepo = (data) => {
  return axios({
    method: 'GET',
    url: Urls.GET_USER_LIST_API,
    params: data
  })
}

export const getCmsGroupPermissionListRepo = (id, data) => {
  return axios({
    method: 'GET',
    url: Urls.GET_CMS_GROUPS_LIST + id + '/permissions/',
    params: data
  })
}

export const getCmsUserPermissionListRepo = (id, data) => {
  return axios({
    method: 'GET',
    url: Urls.GET_USER_API + id + '/permissions/',
    params: data
  })
}

export const getUserRepo = (id, data) => {
  return axios({
    method: 'GET',
    url: Urls.GET_USER_API + id + '/',
    params: data
  })
}

export const putCmsGroupPermissionRepo = (id, data) => {
  return axios({
    method: 'PUT',
    url: Urls.PUT_CMS_GROUP_PERMISSIONS + id + '/add-permissions/',
    data: data
  })
}

export const deleteCmsGroupPermissionRepo = (id, data) => {
  return axios({
    method: 'DELETE',
    url: Urls.PUT_CMS_GROUP_PERMISSIONS + id + '/add-permissions/',
    data: data
  })
}

export const putCmsUserPermissionRepo = (id, data) => {
  return axios({
    method: 'PUT',
    url: Urls.PUT_CMS_USER_PERMISSIONS + id + '/add-permissions/',
    data: data
  })
}

export const deleteCmsUserPermissionRepo = (id, data) => {
  return axios({
    method: 'DELETE',
    url: Urls.PUT_CMS_USER_PERMISSIONS + id + '/add-permissions/',
    data: data
  })
}

// Block Users
export const getBlockUsersRepo = (params) => {
  return axios({
    method: 'GET',
    url: Urls.GET_CMS_BLOCK_USERS,
    params: params
  })
}

export const getBlockUsersSearchRepo = (params) => {
  return axios({
    method: 'GET',
    url: Urls.GET_CMS_SEARCH_USERS,
    params: params
  })
}

export const postBlockUsersRepo = (data) => {
  return axios({
    method: "POST",
    url: Urls.POST_CMS_BLOCK_USERS,
    data: data,
  });
};

export const postUserLogoutRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.CUS_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'POST',
    url: Urls.POST_LOG_OUT_API,
    data: data,
  })
}

export const getStaffRegisterRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.CUS_SERVICE +
      process.env?.REACT_APP_SUB_DOMAIN_NAME,
    method: 'GET',
    url: Urls.GET_CMS_STAFF_REGISTER,
    params: params
  })
}
export const postStaffRegisterRepo = (data) => {
  return axios({
    baseURL:
      ServiceUrls.CUS_SERVICE +
      process.env?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_CMS_STAFF_REGISTER,
    data: data,
  });
};